<script>
import MainMenuView from '../../../shared/views/MainMenuView';
import ListCourseCategoryView from '../lists/ListCourseCategoryView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  components: {
    'page-header-view': PageHeaderView,
    'main-menu-view': MainMenuView,
    'list-course-categories-view': ListCourseCategoryView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <page-header-view
                  icon="fas fa-sitemap"
                  title="Categorías de Cursos"
                  subtitle="Familias de contenido disponibles para clasificar los cursos"
                />
                <div class="la5lo1">
                  <list-course-categories-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
